import { render, staticRenderFns } from "./dustMonitorNew.vue?vue&type=template&id=16d4def9&scoped=true&"
import script from "./dustMonitorNew.vue?vue&type=script&lang=js&"
export * from "./dustMonitorNew.vue?vue&type=script&lang=js&"
import style0 from "./dustMonitorNew.vue?vue&type=style&index=0&id=16d4def9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d4def9",
  null
  
)

export default component.exports